import { render } from "./sm_request.vue?vue&type=template&id=bafa1614&scoped=true"
import script from "./sm_request.vue?vue&type=script&lang=js"
export * from "./sm_request.vue?vue&type=script&lang=js"

import "./sm_request.vue?vue&type=style&index=0&id=bafa1614&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bafa1614"]])

export default __exports__